import { useState, useEffect } from "react";
import { toast } from "../services/toast";
import { C } from "./ui";

const STYLE = {
  error:   { bg: "#FBE9E9", border: "#E09090", icon: "⚠️", color: "#8A2A2A" },
  success: { bg: "#E4F3E6", border: "#90CC98", icon: "✅", color: "#1A5228" },
  info:    { bg: "#EAF0F7", border: "#A9C2E0", icon: "ℹ️", color: "#274866" },
};

export function Toasts() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    return toast.subscribe((t) => {
      setItems((prev) => [...prev, t]);
      setTimeout(() => {
        setItems((prev) => prev.filter((x) => x.id !== t.id));
      }, t.duration);
    });
  }, []);

  const cerrar = (id) => setItems((prev) => prev.filter((x) => x.id !== id));

  if (items.length === 0) return null;

  return (
    <div style={{
      position: "fixed", bottom: 16, right: 16, zIndex: 9999,
      display: "flex", flexDirection: "column", gap: 8, maxWidth: "min(360px, 92vw)",
    }}>
      {items.map((t) => {
        const s = STYLE[t.type] || STYLE.info;
        return (
          <div key={t.id} onClick={() => cerrar(t.id)}
            style={{
              background: s.bg, border: `1px solid ${s.border}`, color: s.color,
              borderRadius: 10, padding: "10px 12px", fontSize: 13, lineHeight: 1.4,
              boxShadow: "0 6px 20px rgba(0,0,0,0.12)", cursor: "pointer",
              display: "flex", gap: 8, alignItems: "flex-start",
              animation: "toastIn 0.18s ease-out",
            }}>
            <span style={{ fontSize: 15, flexShrink: 0 }}>{s.icon}</span>
            <span style={{ flex: 1 }}>{t.message}</span>
          </div>
        );
      })}
      <style>{`@keyframes toastIn{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}`}</style>
    </div>
  );
}
